import { useSelector } from 'react-redux';
import { selectCurrentPalette } from '@store/reducers/accessibilitySlice';
import type { Inspection } from '@lib/spproject/types';

const useNoticeColors = () => {
  const palette = useSelector(selectCurrentPalette);

  return {
    NotChecked: palette.secondary,
    Ok: palette.success,
    Warning: palette.warning,
    Error: palette.error,
  } as Record<Inspection.NoticeType, string>;
};

export default useNoticeColors;